import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';

//OAERDOGAN;449425;10042025
const CustomIcon = styled('span')(({ theme }) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  border: '2px solid gray',
  display: 'inline-block',
}));


const CustomCheckedIcon = styled('span')(({ theme }) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  backgroundColor: 'gray',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export default function ByzMuiRound() {
  return (
    <Checkbox
      icon={<CustomIcon />}
      checkedIcon={
        <CustomCheckedIcon>
          <CheckIcon fontSize="small" />
        </CustomCheckedIcon>
      }
    />
  );
}
